interface OverviewContext {
  checkType: string
  inspectedUnit: string
  inspectedAddress: string
  checkDate: string
  totalItems: number
  majorHazards: string[]
  generalHazards: string[]
}

interface OverviewResponse {
  overview: string
  error?: string
}

export async function generateOverviewWithLLM(ctx: OverviewContext): Promise<string> {
  const controller = new AbortController()
  const timeout = setTimeout(() => controller.abort(), 20000)

  try {
    const response = await fetch('/api/generate-overview', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(ctx),
      signal: controller.signal,
    })

    if (!response.ok) {
      const data: OverviewResponse = await response.json()
      throw new Error(data.error || `HTTP ${response.status}`)
    }

    const data: OverviewResponse = await response.json()
    return data.overview
  } finally {
    clearTimeout(timeout)
  }
}
